import React from 'react';
import { Button } from '@alifd/next';
import axios from 'axios';
import moment from 'moment';

export default function DownloadExcelButton({ func, dbName, text }) {
  const handleDownload = async (db) => {
    const url = `/ezcon/api/getDynamicMenuExcel?type=${db}&demo=no`;
    const resExcel = await axios.get(url, {
      headers: {
        authorization: localStorage.getItem('feathers-jwt'),
      },
      responseType: 'blob',
    });
    const blob = new Blob([resExcel.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${text}_${moment().format('YYMMDD')}.xlsx`;
    link.click();
  };

  return <Button onClick={() => handleDownload(dbName)}>{func.text}</Button>;
}
